import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { useCallback as o } from "react";
import { makeFilterItemPrimitive as i } from "../../../../web/components/Filter/buildGridifyQuery/utils/makeFilterItemPrimitive.js";
import { Row as l } from "../../../../web/components/Row.js";
import { KendoDatePickerField as r } from "../KendoDatePickerField.js";
import { AutocompleteSelectField as a } from "../../AutocompleteSelect/AutocompleteSelectField.js";
const m = ({ control: m2, dateFieldLabel: n = "Дата закінчення т/о", dateFieldName: c = "maintenanceEndDate", selectFieldName: s = "serviceOrganizationId", selectFieldLabel: d = "Техобслуговування", selectAutocompleteValueName: u = "serviceOrganization", isPreviewMode: p, loading: F = false, queryHook: v }) => {
  const b = o((e2) => {
    null === e2 && m2.setFieldValue(c, null);
  }, [c]);
  return e(l, { children: [t(a, { control: m2, name: s, label: d, autocompleteValueName: u, queryHook: v, queryFilters: [i("isActive", true)], onChange: b, preview: p }), t(r, { control: m2, disabled: !m2.values[s], label: n, name: c, preview: p, required: !!m2.values[s], loading: F })] });
};
export {
  m as ServiceOrganizationFieldGroupTemplate
};
//# sourceMappingURL=index.js.map
